import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {OrganizationRegistrationComponent} from './organization-registration/organization-registration.component';
import {LoginComponent} from './login/login.component';
import {PasswordRestoreRequestComponent} from './password-restore-request/password-restore-request.component';
import {NotAuthGuardService} from '@services/guards/not-auth-guard.service';
import {PasswordRestoreComponent} from './password-restore/password-restore.component';
import {ByTokenOnlyGuardService} from './services/by-token-only-guard.service';
import {ActivationGuardService} from './services/activation-guard.service';
import {ActivateInvitationComponent} from './activate-invitation/activate-invitation.component';
import {ActivateInvitedUserService} from './services/activate-invited-user.service';

export const registrationRoutes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    {
        path: 'index',
        redirectTo: 'new',
        pathMatch: 'full'
    },
    {
        path: '',
        canActivate: [NotAuthGuardService],
        children: [
            { path: 'login', component: LoginComponent, data: {title: 'Авторизация'}, },
            { path: 'restore', component: PasswordRestoreRequestComponent, data: {title: 'Восстановление пароля'}, },
            { path: 'new', component: OrganizationRegistrationComponent, data: {title: 'Регистрация'}, },
        ]
    },
    {
        path: 'password-reset',
        canActivate: [ByTokenOnlyGuardService],
        component: PasswordRestoreComponent,
        data: {title: 'Восстановление пароля'},
    },
    {
        path: 'activate-invitation',
        canActivate: [ActivateInvitedUserService],
        component: ActivateInvitationComponent,
        data: {title: 'Активация пользователя'},
    },
    {
        path: 'activate',
        canActivate: [ActivationGuardService],
        children: []
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(registrationRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class RegistrationRoutingModule {}
